<template>
  <div class="container">
    <div class="list">
      <div class="li" v-for="item in merList" :key="item.merchantNo">
        <div class="li-main">
          <div><span>所属银行：</span><span>{{item.platformName}}</span></div>
          <div class="main-body">
            <img src="@/assets/img/img_shanghu.png" alt="">
            <div>
              <div>{{item.merchantName}}</div>
              <div class="mer-code">商户号：{{item.merchantNo}}</div>
            </div>
          </div>

        </div>
        <div class="li-branch" v-for="trem in item.shopList" :key="trem.shopId">
          <div class="shop-code"><span>店铺号：</span><span>{{trem.shopNo}}</span></div>
          <div class="shop-body">
            <img src="@/assets/img/img_dianpu.png" alt="">
            <div>
              <div>{{trem.shopName}}</div>
              <div class="shop-account">
                <span>登录账号：</span><span>{{trem.loginAccount}}</span>
                <span @click="setLoginCode(trem,item)" class="btn">
                  {{trem.loginAccount?"修改":"立即设置"}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <md-dialog :title="title+'登录账号'" v-model="basicDialog.open">
      <md-input-item v-model="newLoginAccount" clearable placeholder="请输入手机号" />
      <br>
      <md-button type="primary" @click="onBasicConfirm" :loading="submitLoading">提交</md-button>
    </md-dialog>
  </div>
</template>

<script>
import { Dialog, InputItem, Button, Toast } from "mand-mobile";
export default {
  created() {
    this.load();
  },
  components: {
    [Dialog.name]: Dialog,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
  },
  data() {
    return {
      title: "设置",
      basicDialog: {
        open: false,
      },
      merList: [],
      form: {
        loginAccount: this.$storage.getItem("loginAccount"),
      },
      newLoginAccount: "",
      submitObj: null,
      submitLoading: false,
    };
  },
  methods: {
    async load() {
      let form = this.form;
      let { data } = await this.$http.post("/h5/merchant/search", form);
      this.merList = data;
    },
    setLoginCode(obj,item) {
      this.submitObj = {
        shopId: obj.shopId,
        platformNo: item.platformNo,
        oldLoginAccount: obj.loginAccount,
      };
      this.newLoginAccount = obj.loginAccount;
      this.title = "设置";
      if (obj.loginAccount) {
        this.title = "修改";
      }
      this.basicDialog.open = true;
    },
    async onBasicConfirm() {
      if (this.newLoginAccount === "")
        return Toast({
          content: "请输入登录账号",
          position: "bottom",
        });
      this.submitLoading = true;
      this.submitObj.newLoginAccount = this.newLoginAccount;
      try {
        await this.$http.post(
          "/h5/merchant/modify-shop-account",
          this.submitObj
        );
        this.load();
        this.basicDialog.open = false;
        Toast.succeed("操作成功");
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.container {
  height: 100%;
  background: #f4f4f4;
  overflow: auto;
  font-size: 28px;
}
.list {
  padding: 30px;
}
.li {
  margin-bottom: 30px;
  padding: 32px 0 0 22px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.main-body {
  display: flex;
  margin-top: 40px;
}
.main-body img {
  width: 74px;
  margin-right: 16px;
}
.li-branch {
  margin: 30px 25px;
}
.mer-code {
  font-size: 24px;
  color: #999999;
  margin-top: 4px;
}
.shop-code {
  background-image: linear-gradient(-270deg, #ffffff 1%, #f8f8f8 100%);
  font-size: 24px;
  color: #999999;
  height: 45px;
  display: flex;
  align-items: center;
  text-indent: 10px;
  border-top: 1px solid #dcdcdc;
  margin-bottom: 30px;
}
.shop-body {
  display: flex;
  align-items: center;
}
.shop-body > img {
  width: 74px;
  margin-right: 16px;
}
.shop-account {
  font-size: 24px;
  color: #999999;
  margin-top: 8px;
}
.btn {
  color: #0085ff;
  margin-left: 5px;
}
</style>